import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuditsService } from '@app/dashboard/shared/services/audits.service';

@Component({
	selector: 'kpa-audit-view',
	templateUrl: './audit-view.component.html',
	styleUrl: './audit-view.component.scss',
})
export class AuditViewComponent implements OnInit {
	public currentAuditId: number;
	public isAudit: boolean = false;
	constructor(
		private auditsService: AuditsService,
		private router: Router
	) {}
	ngOnInit() {
		this.auditsService.getPerformAuditId().subscribe((response) => {
			if (response) {
				this.currentAuditId = response;
				this.isAudit = true;
			}
		});
	}
	closeDialog() {
		this.isAudit = false;
		this.router.navigate(['/auto-logout']);
	}
}
